import useCrud from '../useCrud'

const useDownloadStatisticExcel = kind => {
  const { create: generateExcel } = useCrud(`/admin/v1/stats/download_${kind}`)

  return { generateExcel }
}
export default useDownloadStatisticExcel
